/**
 *
 * @module bamIdentityManagerConfiguration
 *
 */

import ServiceConfiguration from './serviceConfiguration';

/**
 *
 * @class BamIdentityManagerConfiguration
 * @desc Provides configuration information necessary for managing BAM authentication.
 *
 */
export default class BamIdentityManagerConfiguration extends ServiceConfiguration {}



// WEBPACK FOOTER //
// ./src/services/configuration/bamIdentityManagerConfiguration.js